import { CreateRankingCategoryDTO, EditRankingCategoryDTO, RankingCategoryDTO } from './ranking-category-profile.dto';
import { RootState } from '../../../../store/reducers';

export const selectCurrentRankingCategory = (
  state: RootState,
): CreateRankingCategoryDTO | EditRankingCategoryDTO | RankingCategoryDTO => state.rankings.currentCategory;
